export default __webpack_public_path__ + "static/media/w_m_2024_h.1123f09b.jpg";